///<reference path="converter.base.ts"/>

module Meevo.Components.Controls.HideInput {
    export class EmailStringConverter extends ConverterBase implements IStringConverter {

        hide(str: string): string {
            if (/(.*)?@(\w*)?\.(\w{1,3})/g.test(str)) {
                // if it looks like an email address

                const [full, left, domain, other] = /(.*)?@(\w*)?\.(\w*)/g.exec(str);

                return `${left[0]}${left.slice(1, -1).replace(/(.{1})/g, '*')}${left.slice(-1)}@${domain[0]}${domain.slice(1).replace(/(.{1})/g, '*')}.${other}`;
            }

            return super.hide(str);
        }

        valid(str: string): boolean {
            return /(.*)?@(\w*)?\.(\w{1,3})/g.test(str);
        }

    }
}
